import {IconButton, Separator} from 'platform/components';
import {Heading, HStack, Space} from 'platform/foundation';

import {matchPath, useLocation} from 'react-router-dom';

import {isNotNil} from 'ramda';

import i18n from '@dms/i18n';
import {sourcingRoutes} from '@dms/routes';

import {suffixTestId, TestIdProps, useNavigate} from 'shared/web';

import {PREV_URL_COOKIE} from '../../../constants/PREV_URL_COOKIE';
import {SourcingType, useSourcingType} from '../../../hooks/useSourcingType';

export function TitleSection(props: TestIdProps) {
  const {pathname} = useLocation();
  const navigate = useNavigate();
  const sourcingType = useSourcingType();

  const exactPathsWithBackButton = [
    sourcingRoutes.classifieds_userToBuy,
    sourcingRoutes.auctions_userToBuy,
    sourcingRoutes.classifieds_userHidden,
    sourcingRoutes.auctions_userHidden,
    sourcingRoutes.classifieds_userFavourite,
    sourcingRoutes.auctions_userFavourite,
    sourcingRoutes.classifieds_comparison,
    sourcingRoutes.auctions_comparison,
  ];
  const patternPathsWithBackButton = [sourcingRoutes.vehicleDetail, sourcingRoutes.auctionDetail];
  const isDetailRoute = patternPathsWithBackButton.some((path) =>
    isNotNil(matchPath(path, pathname))
  );
  const shouldShowBackButton =
    exactPathsWithBackButton.includes(pathname) ||
    patternPathsWithBackButton.some((path) => isNotNil(matchPath(path, pathname)));

  const handleBackButtonClick = () => {
    const allOffersUrl =
      sourcingType === SourcingType.AUCTIONS ? sourcingRoutes.auctions : sourcingRoutes.classifieds;
    const prevUrl = localStorage.getItem(PREV_URL_COOKIE) || allOffersUrl;

    navigate(isDetailRoute ? prevUrl : allOffersUrl);
  };

  return (
    <HStack>
      {shouldShowBackButton && (
        <>
          <IconButton
            icon="hardware/keyboard_arrow_left"
            priority="primary"
            size="small"
            onClick={handleBackButtonClick}
            data-testid={suffixTestId('backButton', props)}
          />
          <Space horizontal={4} />
        </>
      )}

      <Heading headingLevel={2} size={4} data-testid={suffixTestId('heading', props)}>
        {i18n.t('page.sourcing.labels.sourcing')}
      </Heading>

      <Separator orientation="vertical" />
    </HStack>
  );
}
